import axios from 'axios'
import { getAttributes } from '../imports'

export function getFallbackAds(isSteam, locale) {
    const attributes = getAttributes(locale)
    const origin = isSteam ? attributes.steamOrigin : attributes.defaultOrigin

    // Since we don't have this in japanese or chinese
    let useLocale = 'en'
    if (locale !== 'ja' && locale !== 'zh') useLocale = locale

    return [
        {
            id: '1337',
            src: attributes.fallbackSource.replace('{locale}', useLocale),
            link: attributes.fallbackLink.replace('{origin}', origin),
        },
    ]
}

export function fetchAds(isSteam, locale) {
    const steam = isSteam ? '_steam' : ''

    // Now create the URL:
    const attributes = getAttributes(locale)
    const url = attributes.url.replace('{locale}', locale).replace('{origin}', steam)

    // console.info('ad url: ', url)

    // Do the actual fetching
    return axios.get(url).then((response) => {
        // Make sure that we received a valid response status
        // otherwise throw an error with the response status
        if (response.status !== 200) throw Error(response.status)

        if (response.data.error) {
            throw Error(`(From lambda) ${response.data.errorMessage}`)
        }

        // Return the ads
        return response.data.ads
    })
}



// WEBPACK FOOTER //
// ./src/features/Creatives/data/api.js